import { Component, OnInit, Input } from '@angular/core';
import { AcoesService } from '../acoes.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Gto } from '../../base/vo/gto';
import { FinalizaGTO } from '../../base/vo/finaliza-gto';
import { FinalizaProcedimento } from '../../base/vo/finaliza-procedimento';
import { CalendarModule } from 'primeng/calendar';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { isNullOrUndefined } from 'util';
import { DetalharGtoService } from '../../gto-detalhes/gto-detalhes.service';

@Component({
  selector: 'app-acao-finalizar',
  templateUrl: './acao-finalizar.component.html',
  styleUrls: ['./acao-finalizar.component.css']
})

export class AcaoFinalizarComponent implements OnInit {


  dataFinalizacaoTratamento: Date;

  dates: Date[];
  rangeDates: Date[];
  minDate: Date;
  maxDate: Date;
  
  tr: any;
  ptbr: any;
  invalidDates: Array<Date>

  @Input() gto: Gto;
  @Input() idGto;
  procedimentos;
  display: boolean = false;
  loading: boolean = false;
  sub;

  finalizaGTO: FinalizaGTO = new FinalizaGTO();

  // Variaveis datepicker
  dataOverlay: boolean = false;
  dataOverlayAnimation: boolean = false;


  dataInicial: Date;
  dataFinal: Date;
  dataInicialFiltro: Date;
  dataFinalFiltro: Date;
  dataInicialFinalString: string = '';
  dataValid: boolean = true;
  erroData: string = '';

  constructor(private acoesService: AcoesService, private route: ActivatedRoute, public detalharGtoService: DetalharGtoService) { }

  ngOnInit() {
    this.ptbr = {
      firstDayOfWeek: 1,
      dayNames: ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"],
      dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
      dayNamesMin: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
      monthNames: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"],
      monthNamesShort: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
      today: 'Hoje',
      clear: 'Limpar'
    }
    
    this.tr = {
      firstDayOfWeek : 1
    }

    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let prevMonth = (month === 0) ? 11 : month -1;
    let prevYear = (prevMonth === 11) ? year - 1 : year;
    let nextMonth = (month === 11) ? 0 : month + 1;
    let nextYear = (nextMonth === 0) ? year + 1 : year;
    this.minDate = new Date();
    this.minDate.setMonth(prevMonth);
    this.minDate.setFullYear(prevYear);
    this.maxDate = new Date();
    this.maxDate.setMonth(nextMonth);
    this.maxDate.setFullYear(nextYear);

    let invalidDate = new Date();
    invalidDate.setDate(today.getDate() - 1);
    this.invalidDates = [today,invalidDate];
    
    this.finalizaGTO = new FinalizaGTO();
  }

  carregaDadosGto(idGto) {
    this.loading = true;
    this.acoesService.dadosGto(this.gto.numero).subscribe(
      data => {
        this.gto = data.data;
        this.procedimentos = this.gto.procedimentos;
        this.montaObjFinalizaGTO(this.gto);
        this.loading = false;
      },

      erro => {
        console.log("Erro ao abrir dados da GTO.");
        this.loading = false;
      });
  }

  abrirDialog() {
    if(!isNullOrUndefined(this.gto) && !isNullOrUndefined(this.gto.numero)) {
      this.idGto = this.gto.numero;
    } else {
		//recupera do route
		this.sub = this.route.params.subscribe(params => {
		  this.idGto = +params['numeroGTO'];
		});
	}

    this.carregaDadosGto(this.idGto);
    this.display = true;
  }

  fecharDialog() {
    this.display = false;
  }
  
  montaObjFinalizaGTO(gto) {
  	this.finalizaGTO = new FinalizaGTO();
  	this.finalizaGTO.numero = gto.numero;
  	this.finalizaGTO.error = false;
  	if(!isNullOrUndefined(gto.procedimentos)) {
  		this.finalizaGTO.procedimentos = [];
  		for (let index = 0; index < gto.procedimentos.length; index++) {
  		  let procedimento = gto.procedimentos[index];
  		  let finalizaProcedimento = new FinalizaProcedimento();
  		  finalizaProcedimento.error = false;
  		  finalizaProcedimento.errors = new Array();
  		  finalizaProcedimento.linha = procedimento.linha;
  		  if(procedimento.dataConfirmacao) {
  		  	finalizaProcedimento.dataFinalizacao = new Date(procedimento.dataRealizacao);
  		  	finalizaProcedimento.finalizado = true;
  		  }
  		  this.finalizaGTO.procedimentos[procedimento.linha-1] = finalizaProcedimento;
  		}
  	}
  }
  
  finalizaTratamento() {
  	this.loading = true;
  	this.acoesService.finalizaGTO(this.finalizaGTO).subscribe(
  		data => {
	        this.onSuccess();
	    },
	    errorResponse => {
	        this.callbackErrorResponse(errorResponse);
	    }
	);
  }
  
  onSuccess() {
	this.detalharGtoService.detalharGto(this.gto.numero).subscribe(
      result => {
        this.gto = result.data;
		this.loading = false;
        this.display = false;
      },
      erro => {
        console.log(erro);
        this.loading = false;
        this.display = false;
    });
  }
  
  callbackErrorResponse(errorResponse: any){
    let listErrors: any;
    listErrors = errorResponse.error.errors;
    this.limparErrosAtuais();

    for (let index = 0; index < listErrors.length; index++) {
    	if(listErrors[index].objectName == "finalizarProcedimento" ) {
    		this.finalizaGTO.procedimentos[listErrors[index].field - 1].error = true;
    		this.finalizaGTO.procedimentos[listErrors[index].field - 1].errors.push(listErrors[index].message);
    	} else {
    		this.finalizaGTO.error = true;
    		this.finalizaGTO.errorMessage = listErrors[index].message;
    	}
    }
    
    this.loading = false;

  }
  
  limparErrosAtuais() {
  	this.finalizaGTO.error = false;
  	this.finalizaGTO.errorMessage = "";
  	if(!isNullOrUndefined(this.gto.procedimentos)) {
  		for (let index = 0; index < this.gto.procedimentos.length; index++) {
  			this.finalizaGTO.procedimentos[this.gto.procedimentos[index].linha-1].error = false;
  			this.finalizaGTO.procedimentos[this.gto.procedimentos[index].linha-1].errors = new Array();
  		}
  	}
  }

}


// WEBPACK FOOTER //
// ./src/app/components/acoes/acao-finalizar/acao-finalizar.component.ts